export default "__VITE_ASSET__CmUktx34__"